import {
  DuoToneAssessmentOutline,
  DuoToneCourseOutline,
  DuoToneDashboardOutline,
  DuoToneTrajectoryOutline,
  DuoToneVacancyOutline,
  DuoToneAccountOutline,
  DuoToneTeamOutline,
  DuoToneCategoryOutline,
  DuoToneTagOutline,
  DuoToneCompetenceOutline,
  DuoToneCertificateOutline,
  Documents,
  DuoToneTrajectoryFilled,
  DuoToneCourseFilled,
  DuoToneVacancyFilled,
  DuoToneAssessmentFilled,
} from '@teo/components/icons';

export const InstructionsIcon = ({ isPrimary, className }: any) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className} ${isPrimary && 'fill-primary-05 text-primary-03'}`}
  >
    <path
      d="M9.23007 9.19767C9.07514 9.19767 8.92021 9.14854 8.78796 9.0503C7.97175 8.44192 6.7021 8.13584 4.79762 8.09428C4.38952 8.08672 4.06455 7.74663 4.0721 7.33853C4.07966 6.93043 4.41975 6.60168 4.82785 6.61302C7.0573 6.66214 8.59524 7.05891 9.67218 7.86377C10.0009 8.10939 10.0689 8.57418 9.82333 8.90292C9.67596 9.09942 9.45301 9.20144 9.23007 9.20144V9.19767ZM14.4183 8.90292C14.5656 9.09942 14.7886 9.20144 15.0115 9.20144C15.1664 9.20144 15.3214 9.15232 15.4536 9.05407C16.2698 8.4457 17.5395 8.13962 19.444 8.09806C19.8521 8.0905 20.177 7.75041 20.1695 7.34231C20.1619 6.93799 19.8294 6.6168 19.4289 6.6168H19.4137C17.1843 6.66592 15.6463 7.06268 14.5694 7.86755C14.2407 8.11317 14.1726 8.57795 14.4183 8.9067V8.90292ZM14.4183 12.2282C14.5656 12.4247 14.7886 12.5267 15.0115 12.5267C15.1664 12.5267 15.3214 12.4776 15.4536 12.3794C16.2698 11.771 17.5395 11.4649 19.444 11.4233C19.8521 11.4158 20.177 11.0757 20.1695 10.6676C20.1619 10.2595 19.8218 9.93452 19.4137 9.94207C17.1843 9.9912 15.6463 10.388 14.5694 11.1928C14.2407 11.4385 14.1726 11.9032 14.4183 12.232V12.2282ZM8.78796 12.3794C8.92021 12.4776 9.07514 12.5267 9.23007 12.5267C9.45679 12.5267 9.67974 12.4247 9.82333 12.2282C10.0689 11.8995 10.0009 11.4347 9.67218 11.1891C8.59524 10.3842 7.0573 9.98742 4.82785 9.9383C4.41597 9.92696 4.07966 10.2557 4.0721 10.6638C4.06455 11.0719 4.38952 11.412 4.79762 11.4196C6.7021 11.4611 7.96797 11.7634 8.78796 12.3756V12.3794ZM8.78796 15.7046C8.92021 15.8029 9.07514 15.852 9.23007 15.852C9.45679 15.852 9.67974 15.75 9.82333 15.5535C10.0689 15.2247 10.0009 14.76 9.67218 14.5143C8.59524 13.7095 7.0573 13.3127 4.82785 13.2636C4.41975 13.256 4.07966 13.581 4.0721 13.9891C4.06455 14.3972 4.38952 14.7373 4.79762 14.7448C6.7021 14.7864 7.96797 15.0887 8.78796 15.7009V15.7046Z"
      fill="currentColor"
    />
    <path
      d="M22.6105 17.7489C22.6105 17.7074 22.6105 17.6696 22.6105 17.628C22.5992 17.3408 22.7239 17.065 22.9431 16.876C23.2945 16.57 23.3776 16.0598 23.1433 15.6555L23.0904 15.561C22.8637 15.1756 22.3989 14.9942 21.9719 15.1265L21.9039 15.1492C21.6507 15.2285 21.3749 15.2021 21.1444 15.0698C21.0991 15.0434 21.0575 15.0207 21.0121 14.998C20.9932 14.9905 20.9781 14.9791 20.9592 14.9716C20.6909 14.8355 20.4982 14.5899 20.4378 14.2952V14.2763C20.3433 13.8266 19.9465 13.4979 19.4855 13.4979H19.3722C18.9112 13.4979 18.5144 13.8228 18.4237 14.2763V14.2952C18.3633 14.5899 18.1668 14.8355 17.8985 14.9716C17.8796 14.9791 17.8645 14.9905 17.8456 14.998C17.804 15.0207 17.7587 15.0434 17.7133 15.0698C17.4866 15.2021 17.207 15.2285 16.9538 15.1492L16.8858 15.1265C16.4588 14.9942 15.994 15.1718 15.7673 15.561L15.7144 15.6555C15.4801 16.0561 15.5632 16.57 15.9146 16.876C16.1338 17.065 16.2547 17.3408 16.2472 17.628C16.2472 17.6696 16.2472 17.7074 16.2472 17.7489C16.2472 17.7905 16.2472 17.8283 16.2472 17.8699C16.2585 18.157 16.1338 18.4329 15.9146 18.6218C15.5632 18.9279 15.4801 19.438 15.7144 19.8423L15.7673 19.9368C15.994 20.3222 16.4588 20.5036 16.8858 20.3714L16.9538 20.3487C17.207 20.2693 17.4828 20.2958 17.7133 20.428C17.7587 20.4545 17.8002 20.4772 17.8456 20.4998C17.8645 20.5074 17.8796 20.5187 17.8985 20.5263C18.1668 20.6623 18.3595 20.9079 18.4199 21.2027V21.2216C18.5144 21.6713 18.9112 22 19.3722 22H19.4855C19.9465 22 20.3433 21.675 20.434 21.2216V21.2027C20.4945 20.9079 20.6909 20.6623 20.9592 20.5263C20.9781 20.5187 20.9932 20.5074 21.0121 20.4998C21.0537 20.4772 21.0991 20.4545 21.1444 20.428C21.3711 20.2958 21.6507 20.2693 21.9039 20.3487L21.9719 20.3714C22.3989 20.5036 22.8637 20.326 23.0904 19.9368L23.1433 19.8423C23.3776 19.4418 23.2945 18.9279 22.9431 18.6218C22.7239 18.4329 22.603 18.157 22.6105 17.8699C22.6105 17.8283 22.6105 17.7905 22.6105 17.7489ZM20.6267 18.9468C20.2942 19.2793 19.8936 19.4456 19.4251 19.4456C18.9565 19.4456 18.556 19.2793 18.2234 18.9468C17.8909 18.6143 17.7246 18.2137 17.7246 17.7452C17.7246 17.2766 17.8909 16.876 18.2234 16.5435C18.556 16.211 18.9565 16.0447 19.4251 16.0447C19.8936 16.0447 20.2942 16.211 20.6267 16.5435C20.9592 16.876 21.1255 17.2766 21.1255 17.7452C21.1255 18.2137 20.9592 18.6143 20.6267 18.9468Z"
      fill="currentColor"
    />
    <path
      d="M13.2204 18.977C13.0995 19.0564 12.9823 19.1357 12.8652 19.2226V7.70886C13.3451 5.93664 14.8339 3.93769 21.7641 3.90369V12.3794C21.7641 12.7875 22.0966 13.12 22.5047 13.12C22.9128 13.12 23.2454 12.7875 23.2454 12.3794V3.89613C23.2454 3.0837 22.5803 2.42242 21.7641 2.42242H21.7565C18.624 2.43754 16.285 2.83053 14.611 3.63162C13.5114 4.15686 12.6876 4.85215 12.1208 5.74015C11.554 4.85592 10.7264 4.15686 9.63061 3.63162C7.95664 2.83053 5.62138 2.43754 2.48126 2.42242H2.4737C2.08072 2.42242 1.70662 2.57735 1.43077 2.86076C1.15493 3.14416 1 3.51448 1 3.90369V17.1632C1 18.0588 1.6386 18.7352 2.48126 18.7352C6.07105 18.7352 9.65328 19.0602 11.5426 21.4219C11.5578 21.4408 11.5767 21.4634 11.5956 21.4785C11.5956 21.4785 11.5993 21.4785 11.6031 21.4823C11.6182 21.4974 11.6371 21.5126 11.656 21.5277C11.6636 21.5314 11.6673 21.539 11.6749 21.5428C11.69 21.5541 11.7051 21.5655 11.7202 21.573C11.7278 21.5768 11.7354 21.5806 11.7429 21.5881C11.758 21.5957 11.7731 21.607 11.7883 21.6146C11.7958 21.6146 11.8034 21.6221 11.8109 21.6259C11.8261 21.6335 11.8449 21.641 11.8601 21.6486C11.8676 21.6486 11.8752 21.6524 11.8827 21.6561C11.9016 21.6637 11.9205 21.6675 11.9356 21.6713C11.9432 21.6713 11.9508 21.675 11.9583 21.675C11.9772 21.6788 11.9961 21.6826 12.0188 21.6864C12.0263 21.6864 12.0301 21.6864 12.0377 21.6864C12.0641 21.6864 12.0906 21.6902 12.117 21.6902C12.1435 21.6902 12.1699 21.6902 12.1964 21.6864C12.2039 21.6864 12.2077 21.6864 12.2153 21.6864C12.2342 21.6864 12.2568 21.6788 12.2757 21.675C12.2833 21.675 12.2908 21.675 12.2984 21.6713C12.3173 21.6675 12.3362 21.6599 12.3551 21.6561C12.3626 21.6561 12.3702 21.6524 12.3777 21.6486C12.3966 21.641 12.4118 21.6335 12.4306 21.6259C12.4382 21.6259 12.4458 21.6184 12.4533 21.6146C12.4684 21.607 12.4836 21.5995 12.5024 21.5881C12.51 21.5843 12.5176 21.5806 12.5251 21.573C12.5402 21.5617 12.5553 21.5541 12.5705 21.5428C12.578 21.539 12.5818 21.5352 12.5894 21.5277C12.6082 21.5126 12.6271 21.4974 12.6423 21.4785C12.6423 21.4785 12.6423 21.4785 12.646 21.4748C12.6649 21.4559 12.6838 21.437 12.6989 21.4143C13.0352 20.9949 13.4396 20.583 14.0102 20.2127C14.218 20.0766 14.3389 19.8461 14.3389 19.6005C14.3389 19.0224 13.7003 18.6558 13.2128 18.9695L13.2204 18.977ZM11.3802 19.2226C9.50969 17.8434 6.76634 17.2539 2.49638 17.2539C2.48882 17.235 2.48126 17.2048 2.48126 17.1632V3.90369C6.1504 3.9188 10.4657 4.37225 11.3802 7.70886V19.2189V19.2226Z"
      fill="currentColor"
    />
  </svg>
);

export const learnSidebar = [
  {
    to: '.',
    icon: DuoToneDashboardOutline,
    text: 'links.overview',
    end: true,
    hint: 7,
  },
  {
    to: './courses',
    icon: DuoToneCourseOutline,
    text: 'links.courses',
    end: false,
    type: 'courses',
  },
  {
    to: './learning-paths',
    icon: DuoToneTrajectoryOutline,
    text: 'links.learn_paths',
    end: false,
    type: 'learning-paths',
  },
  {
    to: './assessments',
    icon: DuoToneAssessmentOutline,
    text: 'links.assessments',
    end: false,
    type: 'assessments',
  },
  {
    to: './vacancies',
    icon: DuoToneVacancyOutline,
    text: 'links.vacancies',
    end: false,
    type: 'vacancies',
  },
  {
    to: './instructions',
    icon: InstructionsIcon,
    text: 'links.instructions',
    end: false,
    type: 'instructions',
  },
];

export const manageSidebar = [
  {
    to: ['./teams', './users'],
    icon: DuoToneAccountOutline,
    text: 'links.users',
    end: false,
    hint: 18,
  },
  // {
  //   to: './categories',
  //   icon: DuoToneCategoryOutline,
  //   text: 'links.categories',
  // },
  {
    to: './tags',
    icon: DuoToneTagOutline,
    text: 'links.tags',
    end: false,
    hint: 19,
  },
  {
    to: './competencies',
    icon: DuoToneCompetenceOutline,
    text: 'links.competencies',
    end: false,
    hint: 20,
  },
  {
    to: './report',
    icon: DuoToneAssessmentOutline,
    text: 'links.reports',
    end: false,
    hint: 21,
  },
  {
    to: './certificates',
    icon: DuoToneCertificateOutline,
    text: 'links.certificates',
    hint: 22,
  },
];

export const followUsSidebar = [
  {
    to: '.',
    icon: DuoToneDashboardOutline,
    text: 'links.overview',
    end: true,
    hint: 9,
  },
  {
    to: ['./teams', './users'],
    icon: DuoToneAccountOutline,
    text: 'links.users',
    end: false,
    hint: 10,
  },
  {
    to: './courses',
    icon: DuoToneCourseOutline,
    text: 'links.courses',
    end: false,
    hint: 11,
    type: 'courses',
  },
  {
    to: './learning-paths',
    icon: DuoToneTrajectoryOutline,
    text: 'links.learn_paths',
    end: false,
    type: 'learning-paths',
  },
  // {
  //   to: './growth-trajectories',
  //   icon: DuoToneTrajectoryOutline,
  //   text: 'links.growth_trajectories',
  // },
  {
    to: './assessments',
    icon: DuoToneAssessmentOutline,
    text: 'links.assessments',
    end: false,
    type: 'assessments',
  },
  {
    to: './vacancies',
    icon: DuoToneVacancyOutline,
    text: 'links.vacancies',
    end: false,
    type: 'vacancies',
  },
  {
    to: './instructions',
    icon: InstructionsIcon,
    text: 'links.instructions',
    end: false,
    type: 'instructions',
  },
  {
    to: './competencies',
    icon: DuoToneCompetenceOutline,
    text: 'links.competencies',
    end: false,
  },
];

export const createSidebar = [
  {
    to: '.',
    icon: DuoToneDashboardOutline,
    text: 'links.overview',
    end: true,
    hint: 26,
  },
  {
    to: './courses',
    icon: DuoToneCourseOutline,
    text: 'links.courses',
    end: false,
    hint: 27,
    type: 'courses',
  },
  {
    to: './learning-paths',
    icon: DuoToneTrajectoryOutline,
    text: 'links.learn_paths',
    type: 'learning-paths',
  },
  {
    to: './assessments',
    icon: DuoToneAssessmentOutline,
    text: 'links.assessments',
    end: false,
    type: 'assessments',
  },
  {
    to: './vacancies',
    icon: DuoToneVacancyOutline,
    text: 'links.vacancies',
    end: false,
    type: 'vacancies',
  },
  {
    to: './instructions',
    icon: InstructionsIcon,
    text: 'links.instructions',
    end: false,
    type: 'instructions',
  },
  {
    to: './library',
    icon: DuoToneDashboardOutline,
    text: 'links.library',
    end: false,
  },
];

export const createNewPublication = [
  {
    to: 'courses',
    icon: DuoToneCourseOutline,
    text: 'links.course',
    type: 'courses',
  },
  {
    to: 'assessments',
    icon: DuoToneAssessmentOutline,
    text: 'links.assessment',
    type: 'assessments',
  },
  {
    to: 'vacancies',
    icon: DuoToneVacancyOutline,
    text: 'links.vacancy',
    type: 'vacancies',
  },
  {
    to: 'instructions',
    icon: InstructionsIcon,
    text: 'links.instructions',
    type: 'instructions',
  },
  {
    to: 'learning-paths',
    icon: DuoToneTrajectoryFilled,
    text: 'links.learn_paths',
    type: 'learning-paths',
  },
];

export const organisationSidebar = [
  { to: './details', icon: '', text: 'links.organisation_details' },
  {
    to: './licensing-and-billing',
    icon: '',
    text: 'links.licensing_and_billing',
  },
  /*{ to: './report', icon: '', text: 'links.report' },*/
  // { to: './support-credits', icon: '', text: 'links.support_credits' },
  // {
  //   to: './branding-and-styling',
  //   icon: '',
  //   text: 'links.branding_and_styling',
  // },
  { to: './communication', icon: '', text: 'links.communication' },
  { to: './integrations', icon: '', text: 'links.integrations' },
  // { to: './api', icon: '', text: 'links.api' },
];

export const profileSidebar = [
  { to: './details', icon: '', text: 'links.details', hint: 43 },
  {
    to: './follow-up',
    icon: '',
    text: 'links.profile_follow_up',
    hint: 44,
    role: true,
  },
  {
    to: './emails-notifications',
    icon: '',
    text: 'links.emails_notifications',
  },
  // { to: './email-and-password', icon: '', text: 'links.email_and_password' },
];

export const helpSidebar = [
  { to: '.', text: 'links.overview', end: true },
  { to: './faqs', text: 'links.faq', end: false },
  // {
  //   to: './tutorial',
  //   text: 'links.tutorial',
  //   end: false,
  // },
  // {
  //   to: './tips',
  //   text: 'links.tips',
  //   end: false,
  // },
  {
    to: './contact',
    text: 'links.contact',
    end: false,
  },
  {
    to: './notifications',
    text: 'links.notification',
    end: false,
  },
];

export const LearningPathSidebarAdd = [
  {
    icon: DuoToneCourseFilled,
    text: 'links.course',
    text_add: 'pages.learning_path.btn_add_course',
    type: 'course',
  },
  {
    icon: DuoToneAssessmentFilled,
    text: 'links.assessment',
    text_add: 'pages.learning_path.btn_add_assessment',
    type: 'assessment',
  },
  {
    icon: DuoToneVacancyFilled,
    text: 'links.vacancy',
    text_add: 'pages.learning_path.btn_add_vacancy',
    type: 'leervacature',
  },
  // {
  //   icon: InstructionsIcon,
  //   text: 'links.instructions',
  //   type: 'instructions',
  // },
];
